import { render } from "./FacilityInfoViewCard.vue?vue&type=template&id=0bf59f9a"
import script from "./FacilityInfoViewCard.vue?vue&type=script&lang=js"
export * from "./FacilityInfoViewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__